import React, { Component } from 'react';
import { Button } from 'antd';
import HOCWorkflow from '../HOCWorkflow';
import ModalInvoice from './ModalInvoice';

class Opration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  handleInvoice = params => {
    const { data } = this.props;
    this.props.doTask('next', '', { ...params, uuid: data.uuid });
    this.handleVisible(false);
  };

  handleNext = () => {
    const {
      data: {
        instance: { currentActivity },
      },
      doTask,
    } = this.props;
    if (currentActivity.name === '出纳办理') {
      this.handleVisible(true);
    } else {
      doTask('next');
    }
  };

  render() {
    const { visible } = this.state;
    const {
      data: {
        instance: { currentActivity },
      },
      isLoading,
    } = this.props;
    return (
      <span>
        <Button
          icon="check"
          type="primary"
          onClick={this.handleNext}
          style={{ marginRight: 10 }}
          loading={isLoading || false}
        >
          {currentActivity.name === '出纳办理' ? '开票审核' : '通过'}
        </Button>
        <ModalInvoice
          visible={visible}
          handleOk={this.handleInvoice}
          confirmLoading={isLoading || false}
          handleCancel={this.handleVisible}
        />
      </span>
    );
  }
}

export default HOCWorkflow(Opration);



// WEBPACK FOOTER //
// ./src/components/comm/workflow/invoice/WorkflowInvoice.js